import {InputHTMLAttributes} from 'react';

export default function Checkbox({className = '', ...props}: InputHTMLAttributes<HTMLInputElement>) {
    return (
        <input
            {...props}
            type="checkbox"
            className={
                'rounded border-gray-300 dark:border-gray-600 text-blue-600 shadow-sm focus:ring-blue-500 dark:bg-gray-700 dark:focus:ring-blue-600 ' +
                className
            }
        />
    );
}
